module.exports = __webpack_public_path__ + "static/media/print_rgb_slices-min.580e28fe.gif";